import { ProductType } from '../../common';

export type ProductTypeUrlParameterIndex = 'familyIds' | 'groupIds' | 'productIds';

export const ProductTypeUrlParameter: Readonly<
  Record<keyof typeof ProductType, ProductTypeUrlParameterIndex>
> = {
  Family: 'familyIds',
  Group: 'groupIds',
  Product: 'productIds',
};
